import { render } from "./OrdersCard.vue?vue&type=template&id=7ef6583e"
import script from "./OrdersCard.vue?vue&type=script&lang=js"
export * from "./OrdersCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__